import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'INJURY',
  inside: {
    player: { get: 'injuries' },
  },
});
